import './rxjs-extensions';

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { TrackingnumberComponent } from './trackingnumber.component';
import { TrackingnumberRoutingModule } from './trackingnumber.routing.module';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TrackingnumberRoutingModule,
    ReactiveFormsModule
  ],
  exports: [
    TrackingnumberComponent
  ],
  declarations: [
    TrackingnumberComponent
  ],
  providers: [
    GenericdatasetService
  ],
})
export class TrackingnumberModule { }
